import { makeStyles, useTheme } from "@material-ui/core/styles";
import {logos} from "../../asset";


const drawerWidth = 280;

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  root: {
    display: "flex",
  },
  appBar: {
    boxShadow: '0 4px 2px -2px #eee !important',
    textTransform: 'uppercase',
    backgroundColor: '#fff !important',
    height:'65px',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
},

  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuBtnWrapper:{
    "& button:hover":{
      backgroundColor:'#fff !important',
    },
    "& .MuiIconButton-root":{
        background:'#fff !important',
    },
  },
  menuButton: {
    color: '#000 !important',
    margin: '0 0px 0 -24px !important',
    padding: '20px 29px 20px 20px',
    background: '#fff !importnat',
    borderRadius: '0 !important',
    boxShadow: '15px 0 12px -2px #f0eaea !important',
   
    // '@media(minWidth: 375px)' : {
    //   padding: '20px 21px 20px 20px !important',
    // }
  },

  
hide: {
    display: 'none !important',
},
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  leftToolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },

  infoSectionToolbar: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  //////////  logos and logout

//   avatarCls:{
//     float:'left',
//     margin:'0 10px 0 10px',
// },
// userName:{
//   color: '#383838',
//   float: 'left',
//   fontSize: '14px',
//   textTransform: 'uppercase',
//   position: 'absolute',
//   top: '12px',
//   left: '125px',
//   textAlign:'left'
// },
// userNameTxt:{
//     textTransform:'uppercase',
//     fontSize:'14px',
//     width:'100%',
//     float:'left',
//     textAlign:'left',
//     fontWeight:'bold',
// },
// title:{
//     textTransform:'uppercase',
//     fontSize:'10px',
//     width:'100%',
//     float:'left',
//     textAlign:'left'

// },
// logout:{
//     width: '20px',
//     height:'20px',
//     position:'absolute',
//     right:'0',
//     top:'5px',
//     color:'#000',
//     cursor:'pointer',
//     "& .MuiSvgIcon-root":{
//         fontSize:'26px',
//     },
// },

// logout:{
//   color: '#000',
//   position: 'absolute',
//   right: '0',
//   top: '10px',

//   " & button": {
//     width:'12px',
//     height:'12px',
//     float:'right',
//     border:'none',
//     margin:'0px 15px 0 0',
//     // backgroundImage: `url("${downarrow}")`,
//      backgroundColor: 'unset',
     
      
     
// },
// "& .logoutTooltip::after":{
  
//   position: 'absolute',
//   bottom: '100%',
//   left: '50%',
//   marginLeft: '-5px',
//   borderWidth: '5px',
//   borderStyle: 'solid',
//   borderColor: 'transparent transparent #fff transparent',
// },
// "& .logoutTooltip" :{
//   position: 'absolute',
//   width: '138px',
//   backgroundColor: '#f2b82b',
//   color: '#fff',
//   textAlign: 'center',
//   padding: '4px 0 1px 0',
//   borderRadius: '6px',
//   top: '110%',
//   right: '10px',
//   marginLeft: '-60px',
//   zIndex: '10000001 !important',
//   fontSize: '12px',
//   border: '1px solid #fff',
//   cursor: 'pointer',
//   boxShadow: '0 5px 8px -3px #b3b3b3',

//   "& a:hover":{
//     color: '#fff',
// fontSize: '12px',
// textTransform: 'uppercase',
// fontWeight: 'bold',
// textDecoration:'none',
//   },
// },
// },

innerLogo:{
  backgroundImage: `url("${logos}")`,
  float:'left',
  width:'145px',
  height:'54px',
  margin:'0 0 0 10px',
},
AppName:{
  float:'left',
  width:'255px',
  color:'#353535',
  textTransform:'uppercase',
  fontSize:'20px',
  padding:'10px 0 7px 0px',
  borderLeft:'1px solid #ccc',
  margin:'0 0 0 20px',

},

AppEnv:{
  float:'left',
  width:'300px',
  color:'#ef590f',
  textTransform:'uppercase',
  fontSize:'30px',
  padding:'10px 0 7px 0px',
  borderLeft:'1px solid #ccc',
  margin:'0 0 0 20px',

},

// headerMid:{
//   top: '14px',
//   right: '380px',
//   width: '300px',
//   margin: '0px 0px 0 0',
//   position: 'absolute',
// },

// headerRight:{
//   position:'absolute',
//   width:'380px',
//   right:'0',
//   top:'8px',

//   "& .MuiBadge-colorSecondary": {
//     color: '#fff',
//     backgroundColor: '#ed1c24',
// },
// "& .MuiAvatar-colorDefault" : {
//   color: '#fafafa',
// },
// "& .MuiAvatar-root" : {
//   width: '50px',
//   height: '50px',
//   position: 'absolute',
//   top: '0px',
//   left: '55px',
// },
// },
// alertwrapper:{
//   color: '#000',
//   position: 'absolute',
//   left: '0',
//   top: '17px',
//   "& button":{
//     background:'#fff',
//     border:'none',
//     cursor:'pointer',
//   },
//   "& button:hover":{
//     background:'#fff',
//   },
// },
// userTxt:{
//   float:'left',
//   width:'200px',
//   margin:'8px 10px 0 10px',
  

// },
//  addVendorBtn:{
//    fontSize:'10px',
//    color:'#ed1c24',
//    //position:'absolute',
//    //right:'88px',
//   // top:'20px',
//   // width:'235px',
//    float:'right',
//    textAlign:'right',

//    "& .MuiSvgIcon-root":{
//     color: '#ed1c24',
//     margin: '0px 0 0 0',
//     fontSize: '40px !important',
//    },
//    "& button":{
//     background: 'unset !important',
//     border: 'unset !important',
//     color: '#ed1c24 !important',
//    },
//    "& button:hover":{
//     textDecoration:'none',
//     cursor:'pointer !important',

//    },

//  },
//  addVendorBtnTxt:{
//   color: '#ed1c24',
//   fontSize: '12px',
//   fontWeight: 'bold',
//   textTransform: 'uppercase',
//   textDecoration: 'underline',
//   float: 'right',
//   margin: '13px 0 0 2px',
//  },

//  headerInputWrapper:{
//   float: 'left',
//   margin: '2px 0 0 15px',

//   "& input":{
//       borderRadius: '8px',
//       border: '1px solid #fff4f4',
//       padding: '8px 0',
//       width:'130px',
//       background:'#fff4f4',
//       float: 'left',
//   },
//   "& select":{
//       borderRadius: '8px',
//       border: '1px solid #ededed',
//       padding: '8px 0',
//       width:'130px',
//       background:'#fff4f4',
//       float: 'left',
//   },
// },
// logOutBtnWrapper:{
//   "& button":{

//   },
//   "& button:hover":{
//     background:'#fff',
//   },
//   "& .MuiButton-label":{
//     margin: '15px 0 0 0',
//     float: 'right',
//   },
// },

avatarCls:{
  float:'left',
  margin:'0 10px 0 10px',

},
userName:{
  color: '#383838',
  float: 'right',
  fontSize: '14px',
  textAlign: 'left',
  textTransform: 'uppercase',
  margin:'14px 40px 0 4px',
},
userNameTxt:{
  textTransform:'uppercase',
  fontSize:'14px',
  width:'100%',
  float:'left',
  textAlign:'left',
  fontWeight:'bold',
},
title:{
  textTransform:'uppercase',
  fontSize:'10px',
  width:'100%',
  float:'left',
  textAlign:'left'

},

actData:{
  position: 'absolute',
  right: '0',
},
headerMid:{
  margin: '12px 0px 0 0',
  float:'left',
  [theme.breakpoints.down('sm')]:{
    margin: '35px 0px 0 0',
    width: '20px',
   },
},

headerRight:{
  float:'right',
  [theme.breakpoints.down('sm')]:{
    width: '110px',
    margin:'18px 0 0 0',
   },

  "& .MuiBadge-colorSecondary": {
    color: '#fff',
    backgroundColor: '#ed1c24',
},
"& .MuiAvatar-colorDefault" : {
  color: '#fafafa',
},
"& .MuiAvatar-root" : {
  width: '40px',
  height: '40px',
  float: 'left',
  marginLeft: '20px',
},
},
alertwrapper:{
  color: '#000',
  float: 'left',
  margin: '12px 8px 0 0px',

  [theme.breakpoints.up('xs')]: {
    margin: '15px  8px 0 0px !important',
  },

  "& button":{
    background:'#fff',
    border:'none',
    cursor:'pointer',
  },
  "& button:hover":{
    background:'#fff',
  },
},
userTxt:{
  float:'left',
  width:'200px',
  margin:'8px 10px 0 10px',
  

},
 addVendorBtn:{
   fontSize:'10px',
   color:'#ed1c24',
   //position:'absolute',
   //right:'88px',
  // top:'20px',
  // width:'235px',
   float:'right',
   textAlign:'right',

   "& .MuiSvgIcon-root":{
    color: '#ed1c24',
    margin: '0px 0 0 0',
    fontSize: '40px',
   
    [theme.breakpoints.up('xs')]: {
      fontSize: '22px',
    },
    
   },
   "& button":{
    background: 'unset !important',
    border: 'unset !important',
    color: '#ed1c24 !important',
   },
   "& button:hover":{
    textDecoration:'none',
    cursor:'pointer !important',

   },

 },
 addVendorBtnTxt:{
  color: '#ed1c24',
  fontSize: '12px',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  textDecoration: 'underline',
  float: 'right',
  margin: '5px 0 0 2px',
  display:'block',
 },

 headerInputWrapper:{
  float: 'left',
  margin: '2px 0 0 15px',

  "& input":{
      borderRadius: '8px',
      border: '1px solid #fff4f4',
      padding: '8px 0',
      width:'130px',
      background:'#fff4f4',
      float: 'left',
  },
  "& select":{
      borderRadius: '8px',
      border: '1px solid #ededed',
      padding: '8px 0',
      width:'130px',
      background:'#fff4f4',
      float: 'left',
  },
},
logOutBtnWrapper:{
  "& button":{

  },
  "& button:hover":{
    background:'#fff',
  },
  "& .MuiButton-label":{
    margin: '40px 0 0 22px',
    float: 'right',
  },
},
logOutBtnWrapperDrop:{
  "& button":{

  },
  "& button:hover":{
    background:'#f5f5f5',
  },
  "& .MuiButton-label":{
    float: 'right',
    margin: '0px 0 0 -6px',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#f00',
  },
},
logout:{
  color: '#000',
  float: 'right',
  width:'18px',

  " & button": {
    width:'12px',
    height:'12px',
    float:'right',
    border:'none',
    margin:'0px 15px 0 0',
    // backgroundImage: `url("${downarrow}")`,
     backgroundColor: 'unset',
     
      
     
},
"& .logoutTooltip::after":{
  
  position: 'absolute',
  bottom: '100%',
  left: '50%',
  marginLeft: '-5px',
  borderWidth: '5px',
  borderStyle: 'solid',
  borderColor: 'transparent transparent #fff transparent',
},
"& .logoutTooltip" :{
  position: 'absolute',
  width: '138px',
  backgroundColor: '#f2b82b',
  color: '#fff',
  textAlign: 'center',
  padding: '4px 0 1px 0',
  borderRadius: '6px',
  top: '110%',
  right: '10px',
  marginLeft: '-60px',
  zIndex: '10000001 !important',
  fontSize: '12px',
  border: '1px solid #fff',
  cursor: 'pointer',
  boxShadow: '0 5px 8px -3px #b3b3b3',

  "& a:hover":{
    color: '#fff',
fontSize: '12px',
textTransform: 'uppercase',
fontWeight: 'bold',
textDecoration:'none',
  },
},
},
menuWrapper:{
  ul:{},
},

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,
}));

export default useStyles;